import setAllItemsState from "./setAllItemsState";
import { ITEM_STATE_SAVED_ITEM_LOADED } from "../../constants";
import createPlaceholderItems from "./createPlaceholderItems";

export default (
  state,
  {
    payload: {
      savedItems: { savedItemProducts, itemCount }
    }
  }
) => {
  let items = setAllItemsState(savedItemProducts, ITEM_STATE_SAVED_ITEM_LOADED);

  const placeholdersNeeded = itemCount - savedItemProducts.length;
  if (placeholdersNeeded) {
    items = [
      ...items,
      ...createPlaceholderItems(placeholdersNeeded, items.length)
    ];
  }

  return {
    ...state,
    displayableItemCount: itemCount,
    items,
    indicatives: {
      ...state.indicatives,
      items: undefined
    }
  };
};
